import classnames from 'classnames';
import * as React from 'react';
import './IndicatorDot.scss';

interface IndicatorDotProps {
  active: boolean;
  data: any;
  onClick: (data) => void;
}

export class IndicatorDot extends React.Component<IndicatorDotProps, {}> {
  onClick = () => {
    this.props.onClick(this.props.data);
  };

  render() {
    const { active } = this.props;

    return (
      <span
        onClick={this.onClick}
        className={classnames('indicator-dot', { last: 'me-3' }, { 'indicator-dot-active': active })}
      />
    );
  }
}
